import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {Style} from '../../../Models/Style';
import {StyleService} from '../../../Services/style.service';
import {Property} from '../../../Models/Property';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-manage-style',
  templateUrl: './manage-style.component.html',
  styleUrls: ['./manage-style.component.scss']
})
export class ManageStyleComponent implements OnInit {
  public classicBox;
  @ViewChild('classicForm', {static: false}) child;
  public properties: Property[] = [];
  public lastValue = {style: new Style()};
  public enableSave = true;
  public selectedValues: any[];
  public isEdit = false;
  public styleId: number;

  constructor(
    private route: ActivatedRoute,
    private styleService: StyleService,
    private translate: TranslateService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.selectedValues = [];
    this.route.params.subscribe(params => {
      new Promise((resolve) => {
        if (Helper.isDefined(params['id'])) {
          this.styleId = params['id'];
          this.isEdit = true;
          this.styleService.getStyleItem(this.styleId).subscribe(resp => {
            resolve(resp);
          });
        } else {
          resolve(new Style());
        }
      }).then(style => {
        this.lastValue = {style: (<Style>style)};
        if (this.isEdit) {
          this.lastValue.style.properties.forEach((property) => {
            this.selectedValues.push(property.id);
          });
        }
      }).then(() => {
        this.styleService.getProperties().subscribe((res) => {
          this.properties = res;
          if (this.isEdit) {
            this.lastValue.style.properties.forEach(property => {
              const element = this.properties.find(x => x.id === property.id);
              if (element) {
                element.checked = true;
              }
            });
          }
        });
      }).then(() => {
        this.classicBox = <FormlyFieldConfig>[
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.style.show.style_information') + '</strong></div><hr/>',
          },
        ];
        this.classicBox = <FormlyFieldConfig>[];
        this.classicBox.push(
          {
            fieldGroupClassName: 'row',
            key: 'style',
            fieldGroup: [
              {
                key: 'name',
                type: 'input',
                className: 'col-6',
                templateOptions: {
                  label: this.translate.instant('doctrine.style.name'),

                  required: true,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    pattern: this.translate.instant('errors.invalid'),
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },
              {
                key: 'code',
                type: 'input',
                className: 'col-6',
                templateOptions: {
                  label: this.translate.instant('doctrine.style.code'),

                  required: true,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    pattern: this.translate.instant('errors.invalid'),
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },
            ],
          }
        );
      });
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }

  public onToggle() {
    const checkedProperties = this.properties.filter(x => x.checked);
    this.selectedValues = checkedProperties.map(x => x.id);
  }

  getProperty() {
    return Property;
  }

  submitItem(next: boolean) {
    if (next) {
      const style = JSON.parse(JSON.stringify(this.child.onFormSubmit()));
      style.style.properties = [];
      this.selectedValues.forEach((selectedValue) => {
        style.style.properties.push(selectedValue);
      });
      this.styleService.manageStyle(style, this.isEdit, this.styleId).subscribe(() => {
        this.router.navigateByUrl('/back-office/style/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/style/overview');
    }
  }

}
